module.exports = __webpack_public_path__ + "static/media/f.5078a19f.png";